const validate = values => {
  const errors = {};
  if (!values.reasonDescription) {
    errors.reasonDescription = 'Favor informar o motivo da devolução!';
  }
  return errors;
};

export default validate;
